export const TotalItems = orders => {
  const sumsArray = orders.map(order => {
    const sums = {}

    const addItem = item => {
      const { productId, amount } = item
      if (typeof sums[productId] === 'undefined') sums[productId] = 0
      sums[productId] += amount
    }

    if (order.residents) {
      order.residents.forEach(resident => {
        resident.shoppingList.items.forEach(item => addItem(item))
      })
    }
    order.kioskOrder?.items?.forEach(item => addItem(item))
    order.homeOrder?.shoppingList.items.forEach(item => addItem(item))

    return sums
  })
  const totalSums = {}
  sumsArray.forEach(sums => {
    Object.keys(sums).forEach(productId => {
      if (!totalSums[productId]) totalSums[productId] = 0
      totalSums[productId] += sums[productId]
    })
  })
  return totalSums
}

export const PickedItems = orders => {
  const sumsArray = orders.map(order => {
    const sums = {}
    if (order.pickedItems) {
      order.pickedItems.forEach(item => {
        const { productId, amount } = item
        if (typeof sums[productId] === 'undefined') sums[productId] = 0
        sums[productId] += amount
      })
    }
    return sums
  })
  const totalSums = {}
  sumsArray.forEach(sums => {
    Object.keys(sums).forEach(productId => {
      if (!totalSums[productId]) totalSums[productId] = 0
      totalSums[productId] += sums[productId]
    })
  })
  return totalSums
}

export const PackedItems = orders => {
  const sumsArray = orders.map(order => {
    const sums = {}

    const addItem = item => {
      const { productId, packed } = item
      if (typeof sums[productId] === 'undefined') sums[productId] = 0
      if (packed) sums[productId] += packed
    }

    if (order.residents) {
      order.residents.forEach(resident => {
        resident.shoppingList.items.forEach(item => addItem(item))
      })
    }
    order.kioskOrder?.items?.forEach(item => addItem(item))
    order.homeOrder?.shoppingList.items.forEach(item => addItem(item))

    return sums
  })
  const totalSums = {}
  sumsArray.forEach(sums => {
    Object.keys(sums).forEach(productId => {
      if (!totalSums[productId]) totalSums[productId] = 0
      totalSums[productId] += sums[productId]
    })
  })
  return totalSums
}

export const ItemsInDemand = orders => {
  const items = TotalItems(orders)
  const picked = PickedItems(orders)
  const demands = {}
  Object.keys(items).forEach(productId => {
    const demand = items[productId] - (picked[productId] || 0)
    if (demand > 0) demands[productId] = demand
  })
  return demands
}

export const ItemsInStock = shelves => {
  const supply = {}
  shelves.forEach(shelf => {
    Object.keys(shelf.spaces).forEach(spaceKey => {
      shelf.spaces[spaceKey].items.forEach(item => {
        supply[item.productId] = (supply[item.productId] || 0) + item.amount
      })
    })
  })
  return supply
}

export const MissingItems = (orders, shelves) => {
  const itemsInDemand = ItemsInDemand(orders)
  const itemsInStock = ItemsInStock(shelves)
  const missingItems = {}
  Object.keys(itemsInDemand).forEach(productId => {
    const demand = itemsInDemand[productId]
    const supply = itemsInStock[productId] || 0
    if (supply < demand) missingItems[productId] = Math.abs(supply - demand)
  })
  return missingItems
}

export const MissingItemCounts = missingItems => {
  const missingItemCounts = {
    products: Object.keys(missingItems).length,
    items: 0
  }
  Object.keys(missingItems).forEach(key => {
    missingItemCounts.items += missingItems[key]
  })
  return missingItemCounts
}

export const Stocks = (productId, shelves) => {
  const stocks = []
  shelves.forEach(shelf => {
    Object.keys(shelf.spaces).forEach(spaceId => {
      shelf.spaces[spaceId].items.forEach(item => {
        if (item.productId === productId) {
          const stock = {
            shelfSpaceId: `${shelf.id}-${spaceId}`,
            amount: item.amount
          }
          if (item.expiryDate) stock.expiryDate = item.expiryDate
          stocks.push(stock)
        }
      })
    })
  })
  return _.sortBy(stocks, ['expiryDate', 'amount'], ['asc', 'desc'])
}
